import { computed, toValue, type MaybeRefOrGetter } from 'vue'
import { createQuery } from '@/queries'
import { getAvailableStyles } from '@/features/my-style/api/my-style'
import type { AvailableStyle } from '@/types/my-style'
import type { AxiosResponse } from 'axios'

type AvailableStylesResponse = Awaited<
  ReturnType<typeof getAvailableStyles>
> extends AxiosResponse<infer T>
  ? T
  : never

/**
 * The style catalogue. Without `audience` — the shopper's own (key `['available-styles']`, which the
 * style mutations invalidate exactly); with it — another person's set (T-168, BE-217).
 */
export const useAvailableStylesQuery = (
  audience?: MaybeRefOrGetter<'woman' | 'man' | null | undefined>,
) => {
  return createQuery<AvailableStylesResponse>({
    key: computed(() => {
      const value = toValue(audience)
      return value ? ['available-styles', value] : ['available-styles']
    }),
    fetcher: async () => {
      const response = await getAvailableStyles(toValue(audience) ?? undefined)
      return response.data
    },
    staleTime: 10 * 60 * 1000, // 10 minutes (менее часто меняются)
    enabled: computed(() => true)
  })
}
